// extracted by mini-css-extract-plugin
export var introWrapper = "index-module--introWrapper--2LPNz";
export var imgMobile = "index-module--imgMobile--2v0XV";
export var imgCard = "index-module--imgCard--1AVXQ";
export var imgDesktop = "index-module--imgDesktop--1_s5h";
export var title = "index-module--title--3qZ-l";
export var button = "index-module--button--1khAT";
export var hidde = "index-module--hidde--2_io5";
export var cardContainer = "index-module--cardContainer--2v1Wh";